import { render, staticRenderFns } from "./terms_component.vue?vue&type=template&id=572d19af&"
import script from "../../assets/customer/js/terms.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/terms.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports